import React from 'react'
import _ from 'lodash'
import { Field } from 'formik'
import Select from '../../Select'
import Column from '../Column'

const yearOptions = _.map(_.range(0, 25), (value) => ({ value, label: value }))

export default ({
  baseName,
  onChange,
  ...rest,
}) => (
  <Column size='smaller'>
    <Field name={`${baseName}.endingAge`}>
      {({ field }) => (
        <Select
          {...rest}
          {...field}
          size='smaller'
          options={yearOptions}
          onChange={onChange(field)}
        />
      )}
    </Field>
  </Column>
)
